import axios from "@/axios";

export default {
  categories() {
    return axios.get("/user/permissions/categories/");
  }
};
